import { ZfDialog, ZfDialogContent, ZfDialogFooter, ZfDialogHeader, ZfStack, ZfTextButton } from '@zafire/react';
import type { FunctionComponent } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLinkTopic, useUnlinkTopic } from '../../../api';
import type { TopicDto } from '../../../api/generated/client';
import { TalkingPointListItem, TalkingPointSearch } from '../talking-points';

interface IProps {
    topic: TopicDto;
    onCreatePointClick: () => void;
}

export const AdminTopicEditList: FunctionComponent<IProps> = ({ topic, onCreatePointClick }) => {
    const { t } = useTranslation();
    const { mutate: linkTalkingPointToTopic } = useLinkTopic();
    const { mutate: unlinkTalkingPointToTopic } = useUnlinkTopic();

    const [showPointModal, setShowPointModal] = useState(false);

    const handleUnlinkTalkingPoint = (talkingPointId: number, parentTopicId: number) => unlinkTalkingPointToTopic({ parentTopicId, talkingPointId });

    const handleClosePointModal = () => setShowPointModal(false);

    const handlePointSelected = (pointId: number) => {
        linkTalkingPointToTopic({ parentTopicId: topic.id, talkingPointId: pointId });
        handleClosePointModal();
    };

    return (
        <ZfStack direction="column" spacing="medium" style={{ flex: 1 }}>
            <ZfTextButton hierarchy="secondary" onClick={() => setShowPointModal(true)} size="medium" style={{ alignSelf: 'start' }}>
                {t('contentAdmin.addKeyQuestion')}
            </ZfTextButton>
            {topic.talkingPoints.map((talkingPoint) => (
                <TalkingPointListItem key={talkingPoint.id} point={talkingPoint} onDelete={() => handleUnlinkTalkingPoint(talkingPoint.id, topic.id)} />
            ))}
            <ZfDialog show={showPointModal} onDialogClose={handleClosePointModal} size="small" position="center">
                <ZfDialogHeader>{t('contentAdmin.addKeyQuestion')}</ZfDialogHeader>
                <ZfDialogContent>
                    <TalkingPointSearch onPointClick={handlePointSelected} onCreateClick={onCreatePointClick} />
                </ZfDialogContent>
                <ZfDialogFooter>
                    <ZfTextButton slot="secondary" size="medium" hierarchy="secondary" onClick={handleClosePointModal}>
                        {t('modalCloseButton')}
                    </ZfTextButton>
                </ZfDialogFooter>
            </ZfDialog>
        </ZfStack>
    );
};
